import {
    INCREMENT_STEP,
    DECREMENT_STEP,
    CHANGE_UNIT,
    CHANGE_WIDTH,
    CHANGE_HEIGHT,
    CHANGE_LONG,
    CHANGE_DWDF,
    CHANGE_WT,
    CHANGE_BATHTUB,
    CHANGE_KRW,
    CHANGE_IMAGE,
    SET_BREADCRUMBS,
    GET_BREADCRUMBS,
    FETCH_DATA,
    FETCH_BATHTUB_DATA_SUCCESS,
    FETCH_BATHTUB_DATA_ERROR,
    FETCH_DWDF_DATA_SUCCESS,
    FETCH_DWDF_DATA_ERROR,
    FETCH_WT_DATA_SUCCESS,
    FETCH_WT_DATA_ERROR,
    FETCH_KRW_DATA_SUCCESS,
    FETCH_KRW_DATA_ERROR,
    CHANGE_DATA,
    FETCH_IMAGE,
    FETCH_IMAGE_SUCCESS,
    FETCH_IMAGE_ERROR,
    FETCH_ARTICLE,
    LOADING_SUCCESS,
    SET_SUMMARY, IS_FORM_VALID,
    TOGGLE_PRICES, APRON_DEACTIVATE, TILE_FALNGES_DEACTIVATE,
} from "./types";

import _ from 'lodash';
import {URL} from '../config/Config';
import {fetchDataApi} from '../api/fetchData';
import {
    setRequiredDataFormat, setSwitchValue, deleteUnnecessaryFields, initialClean, setInverterValue,
    secureZargenFields
} from '../utils/prepareData';
import {
    mmCodes, dwdFieldsToDelete, fieldsToDelete, metricConversion, convertStringToNumber, parseNumberToString,
    findElement, wtFieldsToDelete, krwFieldsToDelete
} from '../utils/helpers';
import {Maybe, logging} from '../utils/logging';

// TODO -move to other file: set default value
const defaultLowerLimit = 0;
const defaultUpperLimit = 5;
const sourceUnit = 'mm';

export const stepControl = (direction) => {
    return async (dispatch) => {
        if (direction === 'next') {
            dispatch({type: INCREMENT_STEP})
        } else if (direction === 'prev') {
            dispatch({type: DECREMENT_STEP})
        }
    };
};

export const setBreadCrumbs = (product, step) => {
    return (dispatch) => {
        dispatch({
            type: SET_BREADCRUMBS,
            product,
            step,
        });
    }
}

export const getBreadCrumbs = () => {
    return (dispatch) => {
        dispatch({
            type: GET_BREADCRUMBS,
        });
    }
}

export const togglePrices = () => {
    return (dispatch) => {
        dispatch({
            type: TOGGLE_PRICES,
        });
    }
}

export const fetchData = (uri, method, data, article) => {
    return (dispatch, getState) => {
        return fetchDataApi(uri, method, data)
            .then((result) => {
                // TODO - make new file for data normalization
                const normalisedData = result.Features.Feature.reduce((prev, curr) => {
                    prev[curr.Code] = curr;
                    return prev;
                }, {});
                // convert specific string number to number and change it from mm to cm
                let targetUnit = article === 'krw' ? 'mm' : 'cm';
                Object.values(normalisedData).map((el) => {
                    if (mmCodes.some((code) => {return code === el.Code})) {
                        el.CurrentValue =
                            convertDimensions(
                                convertStringNumber(el.CurrentValue),
                                sourceUnit,
                                targetUnit
                            );
                        if (_.isPlainObject(el.Values.Range)) {
                            el.Values.Range.LowerLimit = el.Values.Range.LowerLimit ?
                                    convertDimensions(
                                        convertStringNumber(el.Values.Range.LowerLimit),
                                        sourceUnit,
                                        targetUnit
                                    )
                                :
                                defaultLowerLimit;
                            el.Values.Range.UpperLimit = el.Values.Range.UpperLimit ?
                                    convertDimensions(
                                        convertStringNumber(el.Values.Range.UpperLimit),
                                        sourceUnit,
                                        targetUnit
                                    )
                                : defaultUpperLimit;
                        }
                        if (_.isArray(el.Values.Range)) {
                            el.Values.Range = el.Values.Range.map((range) => {
                                if (range.UpperLimit && range.LowerLimit) {
                                    range.UpperLimit = convertDimensions(convertStringNumber(range.UpperLimit), sourceUnit, targetUnit);
                                    range.LowerLimit = convertDimensions(convertStringNumber(range.LowerLimit), sourceUnit, targetUnit);
                                }
                                if (Object.keys(range).length === 1 && range.UpperLimit) {
                                    range.UpperLimit = convertDimensions(convertStringNumber(range.UpperLimit), sourceUnit, targetUnit);
                                }
                                if (Object.keys(range).length === 1 && range.LowerLimit) {
                                    range.LowerLimit = convertDimensions(convertStringNumber(range.LowerLimit), sourceUnit, targetUnit);
                                }
                                return range;
                            });
                        }
                    }
                    return el;
                });

                // change GT to number
                Maybe.of(normalisedData.GT)
                    .map((GT) => {
                        return GT.CurrentValue;
                    })
                    .map((GT_value) => {
                        normalisedData.GT.CurrentValue = parseInt(GT_value);
                    });

                // change 0T to number
                Maybe.of(normalisedData.OT)
                    .map((OT) => {
                        return OT.CurrentValue;
                    })
                    .map((OT_value) => {
                        normalisedData.OT.CurrentValue = parseInt(OT_value);
                    });

                // set BREITE and LAENGE and WT_TIEFE
                Maybe.of(normalisedData.W_LAENGE)
                .map((w_laenge) => {
                    normalisedData.LAENGE = {
                        CurrentValue: w_laenge.CurrentValue,
                    };
                    if(parseInt(w_laenge.CurrentValue)===0) {
                        if(article === 'krw') {
                            normalisedData.W_LAENGE.CurrentValue = 1600;
                        } else {
                            normalisedData.W_LAENGE.CurrentValue = findElement(w_laenge.Values.Range, 'StepSize').LowerLimit;
                        }
                    }
                });
                Maybe.of(normalisedData.W_BREITE)
                .map((w_breite) => {
                    normalisedData.BREITE = {
                        CurrentValue: w_breite.CurrentValue,
                    };
                    if(parseInt(w_breite.CurrentValue)===0) {
                        if(article === 'krw') {
                            normalisedData.W_BREITE.CurrentValue = 500;
                        } else {
                            normalisedData.W_BREITE.CurrentValue = findElement(w_breite.Values.Range, 'StepSize').LowerLimit;
                        }
                    }
                });
                Maybe.of(normalisedData.WT_TIEFE)
                .map((wt_tiefe) => {
                    if(parseInt(wt_tiefe.CurrentValue)===0) {
                        normalisedData.WT_TIEFE.CurrentValue = findElement(wt_tiefe.Values.Range, 'StepSize').LowerLimit;
                    }
                });
                Maybe.of(normalisedData.WT_AMV)
                .map((wt_amv) => {
                    if(parseInt(wt_amv.CurrentValue) <= 0) {
                        normalisedData.WT_AMV.CurrentValue = findElement(wt_amv.Values.Range, 'StepSize').LowerLimit;
                    }
                });
                Maybe.of(normalisedData.WT_AM)
                .map((wt_am) => {
                    if(parseInt(wt_am.CurrentValue) <= 0) {
                        normalisedData.WT_AM.CurrentValue = findElement(wt_am.Values.Range, 'StepSize').LowerLimit;
                    }
                    // Set isInvalid
                    normalisedData.WT_AM.isInvalidRange = (parseInt(findElement(wt_am.Values.Range, 'StepSize').LowerLimit) || 0) >= (parseInt(findElement(wt_am.Values.Range, 'StepSize').UpperLimit) || 0);
                });

                // quick fix Whirl
                Maybe.of(normalisedData.WS)
                .map((ws) => {
                    if(ws.CurrentValue !== "00") {
                        normalisedData.ALG.Values.Value = [...normalisedData.ALG.Values.Value, { Code: "-", Description: ["-", "-", "-"] } ];
                    }
                    /*
                    if(ws.CurrentValue !== "00"
                            && (typeof normalisedData.ALG.CurrentValue !== "string" || normalisedData.ALG.CurrentValue === "00")
                            && normalisedData.ALG.Values.Value.length > 1) {
                        normalisedData.ALG.CurrentValue = "01";
                    }*/
                });

                // quick fix handles
                Maybe.of(normalisedData.GFT1)
                .map((gft1) => {
                    if(gft1.CurrentValue !== "00") {
                        normalisedData.GFP1.Values.Value = [...normalisedData.GFP1.Values.Value, { Code: "-", Description: ["-", "-", "-"] } ];
                        normalisedData.GFP2.Values.Value = [...normalisedData.GFP2.Values.Value, { Code: "-", Description: ["-", "-", "-"] } ];
                    }
                });

                // fix PGRUPPE
                Maybe.of(normalisedData.PGRUPPE)
                .map((pg) => {
                    if(article === 'bathtub' && pg.CurrentValue !== "BW") {
                        normalisedData.PGRUPPE.CurrentValue = "BW";
                    }
                });

                // fix FA for krw
                Maybe.of(normalisedData.FA)
                    .map((fa) => {
                        if(article === 'krw' && fa.CurrentValue !== "001") {
                            normalisedData.FA.CurrentValue = "001";
                        }
                    });

                normalisedData.MODEL = result.Model;
                normalisedData.ARTNR = result.ArtNr;
                normalisedData.SGVSBNO = result.SgvsbNo;
                normalisedData.STNO = result.StNo;
                //console.log(normalisedData, "< Data normalised:");
                switch(article) {

                    case 'bathtub':
                        dispatch({
                            type:    FETCH_BATHTUB_DATA_SUCCESS,
                            payload: normalisedData,
                        });
                        break;
                    case 'dwdf':
                        dispatch({
                            type:    FETCH_DWDF_DATA_SUCCESS,
                            payload: normalisedData,
                        });
                        break;
                    case 'wt':
                        dispatch({
                            type:    FETCH_WT_DATA_SUCCESS,
                            payload: normalisedData,
                        });
                    break;
                    case 'krw':
                        dispatch({
                            type:    FETCH_KRW_DATA_SUCCESS,
                            payload: normalisedData,
                        });
                        break;

}
                return Promise.resolve([getState(), article, data.BaseArticle]);
            })
            .catch((err) => {
                switch(article) {

                    case 'bathtub':
                        dispatch({
                            type:    FETCH_BATHTUB_DATA_ERROR,
                            payload: err,
                        });
                        break;
                    case 'dwdf':
                        dispatch({
                            type:    FETCH_DWDF_DATA_ERROR,
                            payload: err,
                        });
                        break;
                    case 'wt':
                            dispatch({
                            type:    FETCH_WT_DATA_ERROR,
                            payload: err,
                        });
                        break;
                    case 'KRW':
                        dispatch({
                            type:    FETCH_KRW_DATA_ERROR,
                            payload: err,
                        });
                        break;

}
            })
    }
}

export const setArticle = (articleID) => {
    return {
        type:    FETCH_ARTICLE,
        payload: articleID,
    }
}


// set loading state (true/false)
export const setLoadingState = (loading) => {
    return {
        type:    LOADING_SUCCESS,
        payload: loading,
    }
}

export const fetchImage = (currentState, article, articleID, type) => {
    return (dispatch) => {
        // TODO - move const to other file
        const bathtubSwitches = ['Z23', 'Z45', 'Z67', 'Z81'];
        const krwSwitches = ['SK23', 'SK45', 'SK67', 'SK81'];
        const dwdfSwitches = ['Z23', 'Z45', 'Z67', 'Z81', 'S23', 'S45', 'S67', 'S81'];
        const wtInverters = ['UL'];
        let dataForSending;
        let sourceFormat = 'cm';
        if (article === 'dwdf') {
            dataForSending = setSwitchValue(currentState, dwdfSwitches);
        } else if (article === 'bathtub') {
            dataForSending = setSwitchValue(currentState, bathtubSwitches);
        } else if (article === 'krw') {
            dataForSending = setSwitchValue(currentState, krwSwitches);
            sourceFormat = 'mm';
        } else {
            dataForSending = setInverterValue(currentState, wtInverters);
        }
        dataForSending = setRequiredDataFormat(dataForSending);
        // transform from cm to mm
        mmCodes.forEach((code) => {
            if (dataForSending[code]) {
                const currentValue = convertStringToNumber(dataForSending[code]);
                dataForSending[code] = metricConversion(currentValue, sourceFormat, 'mm').toString();
            }
        });
        dataForSending = initialClean(dataForSending, ['-']);
        if (article === 'dwdf') {
            dataForSending = deleteUnnecessaryFields(dataForSending, dwdFieldsToDelete);
        } else if (article === 'wt') {
            dataForSending = deleteUnnecessaryFields(dataForSending, wtFieldsToDelete);
        } else if (article === 'krw') {
            dataForSending = deleteUnnecessaryFields(dataForSending, krwFieldsToDelete);
        } else {
            dataForSending = deleteUnnecessaryFields(dataForSending, fieldsToDelete);
        }

        dataForSending = secureZargenFields(dataForSending);
        // change GT to string
        Maybe.of(parseNumberToString(dataForSending.GT)._value)
            .map((value) => {
                dataForSending.GT = value;
            })

        // change OT to string
        Maybe.of(parseNumberToString(dataForSending.OV)._value)
            .map((value) => {
                dataForSending.OV = value;
            })
        //console.log(dataForSending, '> request data')

        // prepare object for sending
        const data = {
            Features:    dataForSending,
            Evaluate:    'true',
            BaseArticle: articleID,
            GenerateGeometryFile: (type === 'DXF') ? 'true' : 'false',
        };
        // TODO - delete this when BE set articeID as BaseArticle for 1893;
        /*
        if ((article === 'bathtub' || article === 'dwdf' || article === 'wt') && articleID === '1893') {
            data.BaseArticle = BATHTUB_ID;
        }
        */
        return fetchDataApi(`${URL}${type === 'DXF' ? 'data' : 'image'}`,'POST', data)
            .then((imageObject) => {
                dispatch({
                    type:    FETCH_IMAGE_SUCCESS,
                    payload: imageObject,
                });
                return Promise.resolve(imageObject)
            })
            .catch((err) => {
                return dispatch({
                    type:    FETCH_IMAGE_ERROR,
                    payload: err,
                })
            })
    }
}


export const changeData = (name, value, articleName, articleID) => {
    return (dispatch, getState) => {
        const payload = {name, value, articleName, articleID};
        dispatch({
            type: CHANGE_DATA,
            payload,
        });
        return Promise.resolve(getState());
    }
}

export const isFormValid = () => {
    return (dispatch, getState) => {
        const payload = {isFormValid: document.querySelector('input:invalid') === null};
        dispatch({
            type: IS_FORM_VALID,
            payload,
        });
        return Promise.resolve(getState());
    }
}

export const setSummary = (name, value) => {
    const payload = {name, value}
    return (dispatch, getState) => {
        dispatch({
            type: SET_SUMMARY,
            payload,
        })
    }
}

export const setApron = () => {
    return (dispatch, getState) => {
        dispatch({
            type: APRON_DEACTIVATE,
        })
    }
}

export const setFlanges = () => {
    return (dispatch, getState) => {
        dispatch({
            type: TILE_FALNGES_DEACTIVATE,
        })
    }
}


// TODO move to other file
const convertStringNumber = (string) => {
    return parseInt(string.replace(/['']/g, ''));
}

// TODO move to other file
const convertDimensions = (currentValue, from = 'mm', to= 'cm') => {
    if (from === 'mm' && to === 'cm') {
        return currentValue/10;
    } else if (from === 'cm' && to === 'mm') {
        return (currentValue * 10).toString();
    } else if (from === 'mm' && to === 'mm') {
        return currentValue/1;
    }
}



// WEBPACK FOOTER //
// ./src/actions/index.js